module.exports = __webpack_public_path__ + "static/media/Old_Women.595911a9.png";